import { ClockIcon, DrivingIcon, InterJourneyIcon, MoonIcon } from "../../assets/imgs";
import CalendarEditIcon from "../../assets/imgs/CalendarEdit";
import CalendarSearchIcon from "../../assets/imgs/CalendarSearch";
import { InfractionTypes } from "../../store/types/infraction";

const InfractionInfo: React.FC<{ type: string, hide_text?: boolean }> = ({ type, hide_text = false }) => {
  if (type === InfractionTypes.EXTRA_HOUR) {
    return (
      <div className="flex items-center justify-center mb-2">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px]">
          <ClockIcon width={19} height={19} color={'#fff'}/>
        </div>
        { hide_text ? '' : <span className="items-center justify-center text-md mt-2 ml-1 font-bold text-dark-blue">Horas Extras</span>}
      </div>
    );
  
  } else if (type === InfractionTypes.INTERJOURNEY_TIME) {
    return (
      <div className="flex items-center justify-center mb-2">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pt-1 pl-2">
          <MoonIcon width={32} height={32} color={'#fff'}/>
        </div>
        { hide_text ? '' : <span className="items-center justify-center text-md mt-2 ml-1 font-bold text-dark-blue">Descanso Interjornada</span>}
      </div>
    );
  } else if (type === InfractionTypes.LONG_WORKING_TIME) {
    return (
      <div className="flex items-center justify-center mb-2">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px]">
          <DrivingIcon width={20} height={20} color={'#fff'}/>
        </div>
        { hide_text ? '' : <span className="items-center justify-center text-md mt-2 ml-1 font-bold text-dark-blue">Direção Ininterrupta</span>}
      </div>
    );
  } else if (type === InfractionTypes.MEAL_TIME) {
    return (
      <div className="flex items-center justify-center mb-2">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pb-[1px] pl-[2px]">
          <InterJourneyIcon width={20} height={20} color={'#fff'}/>
        </div>
        { hide_text ? '' : <span className="items-center justify-center text-md mt-2 ml-1 font-bold text-dark-blue text-bold">Tempo de Refeição</span>}
      </div>
    );
  } else if (type === InfractionTypes.ALTERED_MACRO) {
    return (
      <div className="flex items-center justify-center mb-2">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pt-[5px] pl-[6px]">
          <CalendarEditIcon width={28} height={28} color={'#fff'}/>
        </div>
        { hide_text ? '' : <span className="items-center justify-center text-md mt-2 ml-1 font-bold text-dark-blue">Macros Alteradas</span>}
      </div>
    );
  } else {
    return (
      <div className="flex items-center justify-center mb-2">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pt-[5px] pl-[6px]">
          <CalendarSearchIcon width={30} height={30} color={'#fff'}/>
        </div>
        { hide_text ? '' : <span className="items-center justify-center text-md mt-2 ml-1 font-bold text-dark-blue">Macros Manuais</span>}
      </div>
    );
  }
};

export default InfractionInfo;
